import type { Components, Theme } from "@mui/material";

export const outlinedInputTheme: Components<Theme>["MuiOutlinedInput"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.borderRadius.xs,
      backgroundColor: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.secondary.light,
      },
      "&:hover fieldset.MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.custom.borderHover,
      },
      "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.custom.borderPrimary,
      },
      "&.Mui-disabled:hover": {
        backgroundColor: "inherit",
      },
      "&.Mui-disabled fieldset.MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.custom.borderDisabled,
      },
      "&.Mui-error fieldset.MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.custom.borderError,
      },
      "&.Mui-error:hover": {
        backgroundColor: theme.palette.error.light,
      },
      "& input:-webkit-autofill, & input:-webkit-autofill:focus": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
        WebkitTextFillColor: theme.palette.text.main,
        caretColor: theme.palette.text.main,
      },
      "& input:-webkit-autofill:hover": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.secondary.light} inset`,
        WebkitTextFillColor: theme.palette.text.main,
        caretColor: theme.palette.text.main,
      },
      "&.Mui-error input:-webkit-autofill, &.Mui-error input:-webkit-autofill:focus":
        {
          WebkitBoxShadow: `0 0 0 1000px ${theme.palette.common.white} inset`,
          WebkitTextFillColor: theme.palette.text.main,
          caretColor: theme.palette.text.main,
        },
      "&.Mui-error input:-webkit-autofill:hover": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.error.light} inset`,
        WebkitTextFillColor: theme.palette.text.main,
        caretColor: theme.palette.text.main,
      },
      "&.Mui-disabled input:-webkit-autofill": {
        WebkitBoxShadow: `0 0 0 1000px ${theme.palette.action.disabledBackground} inset`,
        WebkitTextFillColor: theme.palette.text.disabled,
        caretColor: theme.palette.text.disabled,
      },
    }),
  },
};
